import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import React, { useState } from 'react';
import { MobileStepContentElementWrapper } from '@modules/Steps/Shared/Ui/Wrappers/MobileStepContentElementWrapper/MobileStepContentElementWrapper';
import { FragmentInfoMobileDropdown } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/FragmentInfoMobileDropdown/FragmentInfoMobileDropdown';
import css from './FragmentInfoMobileStep3.module.css';
import ItemProgressBar from '@shared/Ui/ProgressBars/ItemProgressBar/ItemProgressBar';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import CircularArrowsIcon from '@shared/Icons/CircularArrowsIcon';
import { ItemTypesListMobile } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/ItemTypesListMobile/ItemTypesListMobile';
import { StepNumberEnum } from '@modules/Steps/Shared/Enums/StepNumberEnum';
import { FragmentInfoFooterStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/FragmentInfoFooterStep3/FragmentInfoFooterStep3';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';

interface Props {
    fragment: ParsedFragmentEntity;
}

export const FragmentInfoMobileStep3: React.FC<Props> = ({ fragment }) => {
    const { progress = 0, itemTypes, uuid } = fragment;

    const [expanded, setExpanded] = useState(false);
    const [clearSelectionAnimation, setClearSelectionAnimation] =
        useState(false);

    const fragmentsViewModel = new FragmentsViewModel();
    const selectedItemsViewModel = new ItemsSelectionViewModel();

    const { id, title } = fragment;
    const totalPrice = fragmentsViewModel.getItemTypesTotal(fragment.itemTypes);
    const selectedTotal = selectedItemsViewModel.getSelectedTotalByItemTypes(
        fragment.itemTypes
    );
    const filteredItemTypes = itemTypes.filter(itemType => itemType.qty > 0);
    const url = fragmentsViewModel.getFragmentGallery(id);

    const handleSelectAll = () => {
        selectedItemsViewModel.selectAllFragmentItems(uuid);
    };

    const handleClearSelection = () => {
        selectedItemsViewModel.removeAllFragmentItemsFromSelected(uuid);
        setClearSelectionAnimation(true);
        setTimeout(() => setClearSelectionAnimation(false), 300);
    };

    const toggleExpand = () => {
        setExpanded(prev => !prev);
    };

    return (
        <MobileStepContentElementWrapper>
            <FragmentInfoMobileDropdown
                isExpanded={expanded}
                toggleExpand={toggleExpand}
                isLaborAndTools={false}
                fragmentTitle={title}
                imgUrl={url}
            />

            <div className={`${css.list} ${expanded ? css.showItemList : ''}`}>
                <div className={css.progressAndBtns}>
                    <div className={css.buttons}>
                        <BasicButton
                            onClick={handleSelectAll}
                            extraClassName={css.selectAllBtnMobile}
                        >
                            Select all
                        </BasicButton>
                        <BasicButton
                            onClick={handleClearSelection}
                            extraClassName={css.clearSelectionBtn}
                            children={
                                <>
                                    <CircularArrowsIcon
                                        height={18}
                                        width={18}
                                        className={
                                            clearSelectionAnimation
                                                ? css.clearSelectionBtnRotatedIcon
                                                : css.clearSelectionBtnIcon
                                        }
                                        fill="currentColor"
                                    />
                                    Clear fragment
                                </>
                            }
                        />
                    </div>

                    <div className={css.progressBar}>
                        <ItemProgressBar
                            total={100}
                            current={progress}
                            selectedNotify={'%'}
                        />
                    </div>
                </div>

                <ItemTypesListMobile
                    itemTypes={filteredItemTypes}
                    stepNumber={StepNumberEnum.STEP3}
                />

                <FragmentInfoFooterStep3
                    grandTotal={totalPrice}
                    selectedTotal={selectedTotal}
                />
            </div>
        </MobileStepContentElementWrapper>
    );
};
